import React from "react";

function Guarantee() {
  return <div>Guarantee</div>;
}

export default Guarantee;
